


const CommonService = {
    getCitizen(code) {

    
    	var c ={1:"Singapore Citizen", 2:"Singapore PR", 3:"Foreign Citizen"}
    
        return c[code];
    },
	getCountry (code){
		var country = {SG:"Singapore", MY:"Malaysia"}; 
		
		if (code in country){
			return country[code];
		}
		else{
			return code;
		}
		
		
	},
	getOfficerPosition (code){
		var c ={1:"Director", 2:"Nominee Director", 3:"Secretary", 4:"Director & Secretary", 5: "Data Protection Officer", 6: "Director & Data Protection Officer"}
    
        return c[code];
		
	},
	
	getAppVersion(){
	
		return process.env.PACKAGE_VERSION || '0';
	}


}

export { CommonService }